import React from "react"
import { useEffect } from "react"
import { scale, HEADER_HEIGHT_L } from "@capioweb/ui-components"

/**
 *   Hook for anchor link scrolling
 */
export const useAnchorLinkScrolling = (): void => {
	const headerOffset = scale(HEADER_HEIGHT_L)
	const headerOffsetRef = React.useRef(headerOffset)

	const clickHandler = React.useCallback((e: any) => {
		const target = e.target
		const anchorLinksSelector = 'a[href*="#"]'

		if (target) {
			const isTarget = target.matches
				? target.matches(anchorLinksSelector)
				: target.msMatchesSelector(anchorLinksSelector)

			if (
				isTarget ||
				(target.closest(anchorLinksSelector) &&
					target.closest(anchorLinksSelector).href)
			) {
				const id = target.closest(anchorLinksSelector).href.split("#")[1]
				const targetBlock = document.getElementById(id)

				if (targetBlock) {
					e.preventDefault()
					window.history.pushState(null, "", `#${id}`)
					const popStateEvent = new PopStateEvent("popstate")

					setTimeout(() => {
						window.scroll({
							top: targetBlock.offsetTop - headerOffsetRef.current,
							left: 0,
							behavior: "smooth",
						})
						window.dispatchEvent(popStateEvent)
					}, 10)
				}
			}
		}
	}, [])

	useEffect(() => {
		document.addEventListener("click", clickHandler, false)
	}, [])

	useEffect(() => {
		headerOffsetRef.current = headerOffset
	}, [headerOffset])
}
